import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "permission-wrapper" }
const _hoisted_3 = { class: "permission-wrapper__label" }
const _hoisted_4 = { class: "permission-wrapper__list" }

import PasswordInput from '@/components/ui/PasswordInput.vue';
import AppBottomBar from '@/components/AppBottomBar.vue';
import { useUserStore } from '@/store/user';
import { Permission, User } from '@/types';
import { CAP_PASSWORD, MIN_LENGTH } from '@/utils/constants';
import { SUBMIT_FORM } from '@/utils/events';
import useVuelidate from '@vuelidate/core';
import { email, helpers, minLength, required } from '@vuelidate/validators';
import { reactive, ref } from 'vue';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserForm',
  props: {
  inProcess: {
    type: Boolean,
    default: false
  },
  formData: {
    type: Object
  },
  edit: {
    type: Boolean,
    default: false
  }
},
  emits: [SUBMIT_FORM],
  setup(__props, { emit: __emit }) {

const userStore = useUserStore();

const emit = __emit;
const { t } = useI18n();
const props = __props;
const localData = reactive({
  existedUser: {} as User,
  allPermissions: [] as Permission[],
  modeEdit: props.edit
});

const preFormData = localData.modeEdit
  ? {
    firstName: props.formData?.firstName,
    lastName: props.formData?.lastName,
    password: CAP_PASSWORD,
    passwordConfirm: CAP_PASSWORD,
    email: props.formData?.email,
    status: props.formData?.status,
    permissions: props.formData?.permissions?.map((permission: Permission) => permission.id)
  }
  : {
    firstName: '',
    lastName: '',
    password: '',
    passwordConfirm: '',
    email: '',
    permissions: [] as number[]
  };
const formDataLocal = reactive(preFormData);

let pm = ref([] as Permission[]);
let clientsPermissionId: number | null = null;
let tagsPermissionId: number | null = null;
let addedDoublePermissions: boolean = false;

userStore.fetchUsersPermissions().then((permissions: Permission[]) => {
  pm.value = permissions;
  permissions.map((permission: Permission) => {
    if (permission.name == 'clients') {
      clientsPermissionId = permission.id;
    }

    if (permission.name == 'tags') {
      tagsPermissionId = permission.id;
    }
  });
});

const rules = {
  firstName: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.FirstName') }), required)
  },
  lastName: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.LastName') }), required)
  },
  password: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.Password') }), required),
    minLenght: helpers.withMessage(
      t('TextFieldError.MinLength', { field: t('TextField.Password'), length: MIN_LENGTH }),
      minLength(MIN_LENGTH)
    )
  },
  passwordConfirm: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.PasswordConfirm') }), required),
    minLenght: helpers.withMessage(
      t('TextFieldError.MinLength', { field: t('TextField.Password'), length: MIN_LENGTH }),
      minLength(MIN_LENGTH)
    ),
    sameAsPassword: helpers.withMessage(
      t('TextFieldError.SameAs', { child: t('TextField.PasswordConfirm'), parent: t('TextField.Password') }),
      (): boolean => {
        return formDataLocal.passwordConfirm === formDataLocal.password;
      }
    )
  },
  email: {
    required: helpers.withMessage(t('TextFieldError.Required', { field: t('TextField.Email') }), required),
    email: helpers.withMessage(t('TextFieldError.Email', { field: t('TextField.Email') }), email)
  }
};
const v$ = useVuelidate(rules, formDataLocal);

function generateFieldErrors(_fieldName: string) {
  return v$.value[_fieldName].$errors.map((errorItem: any) => errorItem.$message);
}

function userPermissionOnChange() {
  const hasClientsPermissionId: boolean =
    formDataLocal.permissions.findIndex((permissionId: number) => permissionId === clientsPermissionId) > -1;
  const hasTagsPermissionId: boolean =
    formDataLocal.permissions.findIndex((permissionId: number) => permissionId === tagsPermissionId) > -1;

  if ((!hasClientsPermissionId || !hasTagsPermissionId) && addedDoublePermissions) {
    formDataLocal.permissions = formDataLocal.permissions.filter(
      (permissionId: number) => permissionId != clientsPermissionId && permissionId != tagsPermissionId
    );
    addedDoublePermissions = false;
  } else if (hasClientsPermissionId && !hasTagsPermissionId && !addedDoublePermissions) {
    formDataLocal.permissions.push(tagsPermissionId);
    addedDoublePermissions = true;
  } else if (!hasClientsPermissionId && hasTagsPermissionId && !addedDoublePermissions) {
    formDataLocal.permissions.push(clientsPermissionId);
    addedDoublePermissions = true;
  }
}

async function onClick() {
  if (await v$.value.$validate()) {
    emit(SUBMIT_FORM, { formData: formDataLocal, localData });
  } else {
    return false;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "pa-0"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_form, { class: "pa-4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "4",
                xl: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.firstName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formDataLocal.firstName) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.FirstName'),
                    "error-messages": generateFieldErrors('firstName'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "4",
                xl: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.lastName,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formDataLocal.lastName) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.LastName'),
                    "error-messages": generateFieldErrors('lastName'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "4",
                xl: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: formDataLocal.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formDataLocal.email) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.Email'),
                    "error-messages": generateFieldErrors('email'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "4",
                xl: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(PasswordInput, {
                    modelValue: formDataLocal.password,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formDataLocal.password) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.Password'),
                    "error-messages": generateFieldErrors('password'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "4",
                xl: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(PasswordInput, {
                    modelValue: formDataLocal.passwordConfirm,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formDataLocal.passwordConfirm) = $event)),
                    modelModifiers: { trim: true },
                    variant: "outlined",
                    color: "primary",
                    "bg-color": "input-background",
                    label: _ctx.$t('TextField.PasswordConfirm'),
                    "error-messages": generateFieldErrors('passwordConfirm'),
                    required: "",
                    autocomplete: "off"
                  }, null, 8, ["modelValue", "label", "error-messages"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (__props.edit)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "12",
                    md: "6",
                    lg: "4",
                    xl: "4"
                  }, {
                    default: _withCtx(() => [
                      (formDataLocal.status > 0)
                        ? (_openBlock(), _createBlock(_component_v_switch, {
                            key: 0,
                            modelValue: formDataLocal.status,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formDataLocal.status) = $event)),
                            "hide-details": "",
                            "true-value": 1,
                            "false-value": 2,
                            label: 
              _ctx.$t('TextField.Status') +
                ': ' +
                (formDataLocal.status == true ? _ctx.$t('Label.UserStatus.Active') : _ctx.$t('Label.UserStatus.Disabled'))
            
                          }, null, 8, ["modelValue", "label"]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(`${_ctx.$t('TextField.Status')}: ${_ctx.$t('Label.UserStatus.NoConfirmed')}`), 1))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12",
                md: "6",
                lg: "4",
                xl: "4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('Label.User.Permissions')), 1),
                    _createElementVNode("div", _hoisted_4, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pm), (permission) => {
                        return (_openBlock(), _createBlock(_component_v_checkbox, {
                          key: permission.id,
                          modelValue: formDataLocal.permissions,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formDataLocal.permissions) = $event)),
                          class: "mr-4",
                          color: "primary",
                          "hide-details": "",
                          value: permission.id,
                          label: _ctx.$t(`Label.Permission.${permission.name}`)
                        }, null, 8, ["modelValue", "value", "label"]))
                      }), 128))
                    ])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(AppBottomBar, { class: "justify-end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            color: "primary",
            variant: "flat",
            disabled: __props.inProcess,
            loading: __props.inProcess,
            onClick: onClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(localData.modeEdit ? _ctx.$t('Button.Save') : _ctx.$t('Button.Create')), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})